import {ReactComponent as IconDiscord} from '#/components/icons/ico-discord.svg';
import {ReactComponent as IconTwitter} from '#/components/icons/ico-twitter.svg';
import {ClassName, DefaultChildren} from '#/utils/utils';
import {ComponentProps, FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const SocialLinks: FunctionComponent = () => {
  const {t} = useTranslation('translation');

  return (
    <>
      <UrlLink href='https://discord.gg/5njaDH5y39'>
        <IconDiscord className='w-4 h-4 stroke-white' />
      </UrlLink>

      <Separator />

      <UrlLink href='https://twitter.com/sharedotland'>
        <IconTwitter className='w-4 h-4 stroke-white' />
      </UrlLink>

      <Separator />

      <EmailUsLink>{t('pages.home.footer.links.emailUs')}</EmailUsLink>

      <Separator />

      <UrlLink href='https://bit.ly/sharelandwiki'>{t('pages.home.footer.links.knowledgeBase')}</UrlLink>

      <Separator />

      <UrlLink href='https://www.iubenda.com/terms-and-conditions/41900760'>
        {t('pages.home.footer.links.terms')}
      </UrlLink>

      <Separator />

      <UrlLink href='https://www.iubenda.com/privacy-policy/41900760'>{t('pages.home.footer.links.privacy')}</UrlLink>
    </>
  );
};

const Separator: FunctionComponent = () => {
  const {t} = useTranslation('translation');
  return <div>{t('pages.home.footer.linkSeparator')}</div>;
};

const UrlLink: FunctionComponent<ComponentProps<'a'>> = ({href, children, ...rest}) => (
  <a className='flex items-center gap-1 hover:opacity-70' href={href} target='_blank' rel='noreferrer' {...rest}>
    {children}
  </a>
);

export const EmailUsLink: FunctionComponent<ClassName & DefaultChildren> = ({className, children}) => {
  return (
    <a
      className={`flex items-center gap-1 hover:opacity-70 ${className}`}
      href='mailto:hello@share.land'
      target='_blank'
      rel='noreferrer'
    >
      {children}
    </a>
  );
};
